import { render, staticRenderFns } from "./LoginPartner.vue?vue&type=template&id=fdb6ebba&scoped=true&"
import script from "./LoginPartner.vue?vue&type=script&lang=js&"
export * from "./LoginPartner.vue?vue&type=script&lang=js&"
import style0 from "./LoginPartner.vue?vue&type=style&index=0&id=fdb6ebba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb6ebba",
  null
  
)

export default component.exports